import { useEffect, useState } from "react";
import { getConnectedUser, getToken } from "./loginApi.ts";
import LoginScreenUI from "./LoginScreenUI.tsx";
import MainContainer from "../main/MainContainer.tsx";
import { Doctors } from "cadendar-shared";

const LoginSwitcher = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [token, setToken] = useState("");
  const [user, setUser] = useState<Doctors | null>(null);
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      setToken(token);
    }
  }, []);
  useEffect(() => {
    if (token) {
      getConnectedUser(token).then((user) => {
        setUser(user);
      });
    }
  }, [token]);
  const handleSubmit = async (obj: {
    emailOrUsername: string;
    password: string;
  }) => {
    setIsSubmitting(true);
    const { token: _token } = await getToken(obj.emailOrUsername, obj.password);
    setToken(_token);
    await localStorage.setItem("token", _token);
    const user = await getConnectedUser(_token);
    setUser(user);
    setIsSubmitting(false);
  };
  if (token && user) {
    return <MainContainer token={token} user={user} />;
  } else {
    return (
      <LoginScreenUI onSubmit={handleSubmit} submitDisabled={!isSubmitting} />
    );
  }
};

export default LoginSwitcher;
